import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-sftp-upload',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './sftp-upload.component.html',
  styleUrl: './sftp-upload.component.scss',
})
export class SftpUploadComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() readonly = false;
  @Input() showValidation = true;
}

